import React, { Component } from 'react';
import { Modal, Input, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Config = {
    add: {
        title: '添加文档分类',
        url: API_URL.folder.addCatalog,
    },
    edit: {
        title: '修改文档分类',
        url: API_URL.folder.updateCatalog,
    },
}
const { TextArea } = Input;

class UpdateCatalog extends Component {
    state = {
        config: {},
        visible: false,
        loading: false,
        id: '',
        catalogName: '',
        desc: '',
    }

    show = (type, id, name, desc) => {
        this.setState({
            config: Config[type],
            visible: true,
            id,
            catalogName: name,
            desc,
        });
    }

    hide = () => {
        this.setState({
            config: {},
            visible: false,
        });
    }

    submit = () => {
        const {
            config,
            id,
            catalogName,
            desc,
        } = this.state;
        if (!catalogName) {
            message.warning('请输入文档分类名称');
            return;
        }
    
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: config.url,
            data: {
                id,
                parentId: id,
                catalogName,
                desc,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e) => {
        this.setState({ catalogName: e.target.value });
    }

    handleTextAreaChange = (e) => {
        this.setState({ desc: e.target.value });
    }

    getContent = () => {
        const { catalogName, desc } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}文档分类名称:</div>
                    <div className="item-right">
                        <Input
                            style={{ width: 180 }}
                            placeholder="请输入"
                            value={catalogName}
                            onChange={e => this.handleInputChange(e)}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">文档备注说明:</div>
                    <div className="item-right">
                        <TextArea
                            rows={5}
                            style={{ width: 180 }}
                            placeholder="请输入"
                            value={desc}
                            onChange={e => this.handleTextAreaChange(e)}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { config, visible, loading } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
                bodyStyle={{ minHeight: 120 }}
            >
                <Spin spinning={loading}>
                    <div className="modal-content">
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateCatalog;


// WEBPACK FOOTER //
// ./src/components/personal/file/UpdateCatalog.js